import { ProductType } from "@/store/subscription/offer/type";

export const PRODUCT_TYPES: ProductType[] = [ProductType.GREEN100];
